module.exports = __webpack_public_path__ + "static/media/video.f7c640ae.svg";